import contact from "./contact.json";
import error from "./error.json";
import footer from "./footer.json";
import reviews from "./reviews.json";
import search from "./search.json";
import account from "./account";
import address from "./address";
import header from "./header";
import notification from "./notification";
import home from "./home.json";

export default {
  contact,
  error,
  footer,
  reviews,
  search,
  account,
  address,
  header,
  notification,
  home,
};
